<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Salas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="grey darken-2" dark class="mb-1" v-on="on">
                  Nuevo
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-select
                            v-model="editedItem.materia_id"
                            label="Materia"
                            :items="ListMaterias"
                            item-text="nombre"
                            item-value="id"
                            :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.nombre" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.email" label="Email" :rules="emailRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" dark @click.native="editSala(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                          <v-btn v-else color="yellow darken-2" dark @click.native="addSala(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-data-table
            dense
            :headers="headers"
            :items="listSalas"
            item-key="id"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
            no-data-text="No hay Salas registradas"
          >
            <template v-slot:item.materia="{ item }">
              <span v-if="item.materia">{{ item.materia.nombre }}</span>
              <span v-else-if="item.materia_id">{{ getMateriaNombre(item.materia_id) }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon v-if="!item.deleted_at" class="mr-2" color="green">mdi-check-bold</v-icon>
              <v-icon v-else class="mr-2" color="grey">mdi-minus</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon color="orange" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon v-if="!item.deleted_at" color="red" @click="deleteSala(item)">mdi-close</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="listSalas.length > itemsPerPage">
            <v-pagination v-model="page" :length="pageCount" :total-visible='7'></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      valid: true,
      dialog: false,
      loading:false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      headers: [
        { text: 'Sala', value: 'nombre', sortable: true },
        { text: 'Materia', value: 'materia', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      editedIndex: -1,
      activo: true,
      editedItem: {
        materia_id:'',
        nombre:'',
        email:'',
      },
      defaultItem: {
        materia_id:'',
        nombre:'',
        email:'',
      },
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'Este campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo válido',
      ],
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters(["listSalas", "ListMaterias"]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Sala' : 'Editar Sala'
    }
  },
  mounted() {
    this.getSalas();
    this.getMaterias();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    getMateriaNombre(materia_id){
      const m = this.ListMaterias.find(x => x.id === materia_id)
      return m ? m.nombre : materia_id
    },
    getSalas() {
      this.loading = true;
      this.$store.dispatch("GET_SALAS",  { url: "/salas-admin" }).then((response) => {
        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        console.log(err);
      });
    },
    getMaterias(){
      this.$store.dispatch("GET_MATERIAS",  { url: "/materias" }).then((response) => {
      })
      .catch(err => {
        console.log(err);
      });
    },
    editItem (item) {
      this.editedIndex = this.listSalas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      // asegurar materia_id mapeado
      if(item.materia && !this.editedItem.materia_id){
        this.editedItem.materia_id = item.materia.id
      }
      this.dialog = true
      if (this.editedItem.deleted_at) {
        this.activo = false
      }else {
        this.activo = true
      }
    },
    addSala(item){
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("SAVE_SALA",  { url: "/sala", data: item } ).then(response => {
          this.loading = false;
          this.close();
          this.$swal({
            icon: 'success',
            title: 'Sala guardada correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getSalas();
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          const msg = error.response && error.response.data && (error.response.data.msg || error.response.data.message)
          Swal.fire({
            icon: 'error',
            title: msg || 'Error al guardar sala',
            confirmButtonText: "Aceptar"
          })
        });
      }
    },
    editSala(item){
      if (this.$refs.form.validate()) {
        item.activo = this.activo
        this.loading = true;
        this.$store.dispatch("EDIT_SALA",  { url: "/sala/" + item.id, data: item } ).then(response => {
          this.loading = false;
          this.$swal({
            icon: 'success',
            title: 'Sala actualizada correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.close();
          this.getSalas();
        })
          .catch(error => {
            this.loading = false;
            console.log(error);
            const msg = error.response && error.response.data && (error.response.data.msg || error.response.data.message)
            Swal.fire({
              icon: 'error',
              title: msg || 'Error al actualizar sala',
              confirmButtonText: "Aceptar"
            })
          });
      }
    },
    deleteSala (item) {
      this.$swal({
        title: '¿Desea eliminar la sala "' + item.nombre + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
            this.$store.dispatch("DELETE_SALA",  { url: "/sala/" + item.id } ).then(res => {
              console.log(res);
            Swal.fire({
              icon: 'success',
              title: 'Sala eliminada correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getSalas();
          })
          .catch(err => {
            console.log(err);
            const msg = err.response && err.response.data && (err.response.data.msg || err.response.data.message)
            Swal.fire({
              icon: 'error',
              title: msg || 'Error al eliminar',
              confirmButtonText: "Aceptar"
            })
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        if(this.$refs.form) this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
